
import { daysOfTheWeek } from "../elements/Days";
import { monthlyDates } from "../elements/MonthlyDates";
import { offsetDays } from "../elements/OffsetDays";
import { doNavigation } from "../elements/Navigation";
import { renderHeader, renderFooter } from "../elements/HeadFoot";

let
	monthly_view_count = 1,
	monthlyHTML = '',
	dd_html = '',
	today = new Date(),
	joinPerformancesByYearMonth = [];

const tapAction = window.ontouchstart === null ? 'touchstart' : 'click';

export const renderMonthly = (calendar) => {
	let performances = limelight.performances;
	// Loops all performances
	for (let di = 0; di < performances.length; di++) {
		const todayYear = today.getFullYear();
		const todayMonthRaw = today.getMonth() + 1;
		const todayMonth = todayMonthRaw > 9 ? todayMonthRaw : '0' + todayMonthRaw;
		const todayOperator = todayYear + '-' + todayMonth;

		let performanceYear = performances[di].date.split('-')[0];
		let performanceMonth = performances[di].date.split('-')[1];
		let performanceMonthYear = performanceYear + '-' + performanceMonth;

		joinPerformancesByYearMonth.indexOf(performanceMonthYear) === -1 && todayOperator <= performanceMonthYear ? joinPerformancesByYearMonth.push(performanceMonthYear) : null;
	}

	// Reverse order of peformances by month
	joinPerformancesByYearMonth.reverse();

	daysOfTheWeek('ddd').forEach(d => {
		if (d) {
			dd_html += `<div class="calendar__day">${d}</div>`;
		}
	});

	calendar.innerHTML = '';

	// Render Months
	for (let index = 0; index < joinPerformancesByYearMonth.length; index++) {

		const monthcount = index + 1;
		const month = joinPerformancesByYearMonth[index];
		let isActive = monthcount > monthly_view_count ? false : true;
		// if a starting month has been specified, decide based on that
		if (calendar.dataset.start_month) {
			isActive = calendar.dataset.start_month == month ? true : false;
		}

		monthlyHTML += `
            <div class="calendar__month ${isActive ? 'calendar__month--active' : ''}">
                ${renderHeader(month, calendar)}
                <div class="calendar__grid-container">
                    <div class="days">
                      ${dd_html ?? ''}
                    </div>
                    <div class="calendar__grid">
                        ${offsetDays(month, 'before')}
                        ${monthlyDates(month, performances, today)}
                        ${offsetDays(month, 'after')}
                    </div>
                </div>
                ${renderFooter(calendar)}
            </div>`
	}

	calendar.innerHTML = monthlyHTML;

	doNavigation(calendar, null);

}